import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { postAddSubVendor } from 'redux/actions/UserSubVendor';
import { postAddDriver } from 'redux/actions/UserDriver';
import { postAddVehicle } from 'redux/actions/UserVehicle';
import { getCar } from 'redux/actions/UserCar';
import CommonDialog from 'components/commonDialog/CommonDialog';
import {
  driverDialogData,
  subVendorDialogData,
  vehicleDialogData,
} from 'pages/vendor/VendorBreadCrumbData';
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';

function AddSubVendorDriver() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState('');
  const [type, setType] = useState('');
  const [defaultValue, setDefaultValue] = useState({});
  const id = localStorage.getItem('ID');
  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const carOption = carList?.body?.map((val, idx) => {
    return { value: val?.id, label: val?.carType, seater: val?.seater };
  });
  const role = localStorage.getItem('role');
  const parentCompany = localStorage.getItem('parentCompany')
  const companyId = localStorage.getItem('companyId');
  const [selectedImage, setSelectedImage] = useState(null);
  const postAddVehicleSuccess = useSelector((state) => state?.userAddVehicle?.userAddVehicle?.success);
  const [showOtherComponent,setShowOtherComponent] = useState(false)

  useEffect(() => {
    dispatch(getCar());
  }, []);

  useEffect(() => {
    const value = {
      name:parentCompany
    }
    setDefaultValue(value)
  }, [parentCompany]);

  const filterVehicleData = {
    id: companyId,
    status: '',
    page: '',
    pageSize: '',
    date: '',
    type: 'subvendor',
  };

  const handleOpenDialog = () => {
    setOpen(true);
    setType('Sub Vendor');
    setFormData(subVendorDialogData);
  };

  const handleOpenDialogDriver = () => {
    setOpen(true);
    setType('Driver');
    setFormData(driverDialogData);
  };

  const handleOpenDialogVehicle = () => {
    setOpen(true);
    setType('Vehicle');
    setFormData(vehicleDialogData(carOption));
  };

  const onImageChange = (val) => {
    setSelectedImage(val);
  };

  const onSubmit = (val, code) => {
    if (type === 'Driver') {
      const data = {
        mobile: val.number,
        firstName: val.driverName,
        lastName: '',
        altmobile: val.mobile,
        DOB: val.birthday,
        permanentaddress: val.permanentaddress,
        currentaddress: val.currentaddress,
        covid: val.covid,
        email: val.email,
        countryCode: code,
        parentId: companyId,
        vendorId: id,
        companyName: 'abc12121qw' + val.number,
      };
      dispatch(postAddDriver(data));
      setOpen(false);
    } else if (type === 'Vehicle') {
      const data = {
        ...val,
        carType: 'COC',
        seating: parseInt(val?.seating),
        id: companyId,
        type: 'vendor',
        avtar: selectedImage,
      };
      let formData = new FormData();
      Object.keys(data).map((val) => {
        formData.append(val, data[val]);
      });
      dispatch(postAddVehicle(formData));
      setOpen(true)
    } else {
      const data = {
        mobile: val.number,
        firstName: '',
        lastName: '',
        email: val.email,
        countryCode: code,
        vendorId: id,
        companyName: val.vendorName,
      };
      dispatch(postAddSubVendor(data));
      setOpen(false);
    }
  };

  useEffect(() => {
    if (postAddVehicleSuccess) {
      setShowOtherComponent(true);
    }else{
      setShowOtherComponent(false);
    }
  }, [postAddVehicleSuccess]);

  const handleClose = () => {
    setOpen(false);
    setShowOtherComponent(false);
  };

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        className="marginBlock30"
      >
        {role !== 'subVendorCompany' && (
          <Grid
            item
            sm={6}
            md={3}
            xs={12}
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            className="addVendorBg"
          >
            <Grid item onClick={handleOpenDialog} className=" vendorAdd">
              +
            </Grid>
            <Grid item className="textCenter marginTop25 fontMedium font28">
              Add Sub-Vendor
            </Grid>
          </Grid>
        )}

        <Grid
          item
          sm={6}
          md={3}
          xs={12}
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          className="addVendorBg"
        >
          <Grid item onClick={handleOpenDialogDriver} className=" vendorAdd">
            +
          </Grid>
          <Grid item className="textCenter marginTop25 fontMedium font28">
            Add Driver
          </Grid>
        </Grid>

        <Grid
          item
          sm={6}
          md={3}
          xs={12}
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          className="addVendorBg"
        >
          <Grid item onClick={handleOpenDialogVehicle} className=" vendorAdd">
            +
          </Grid>
          <Grid item className="textCenter marginTop25 fontMedium font28">
            Add Vehicle
          </Grid>
        </Grid>
      </Grid>
      {type === 'Vehicle' && (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={'dialogButton'}
          onSubmittBtn={onSubmit}
          selectType={'Create'}
          type={type}
          setOpen={false}
          defaultValues={defaultValue}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          tabName ={'vehicle'}
        />
      )}

      {open && type !== 'Vehicle' && (
        <CommonDialog
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={'dialogButton'}
          onSubmittBtn={onSubmit}
          type={type}
          selectType={'Create'}
          defaultValues={defaultValue}
        />
      )}
    </div>
  );
}

export default AddSubVendorDriver;
